import { render, staticRenderFns } from "./HomeInboxItem.vue?vue&type=template&id=676ed61e&"
import script from "./HomeInboxItem.vue?vue&type=script&lang=js&"
export * from "./HomeInboxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports